//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { fetch } from '@/page/index';

export default {
  name: 'SrmIMManage',
  data() {
    return {
      messageList: [],
      loading: false
    };
  },
  mounted() {
    this.loadMessageList();
  },
  methods: {
    // 加载消息列表
    loadMessageList() {
      this.loading = true;
      const params = {
        pageIndex: 1,
        pageRows: 20
      };
      
      fetch.srmBaseNotificationRestful_listByPage(params).then(res => {
        this.loading = false;
        if (res.status === 'S' && res.data) {
          this.messageList = res.data.map(item => ({
            notificationId: item.notificationId,
            content: item.notificationTitle,
            date: this.formatDate(item.lastUpdateDate)
          }));
        } else {
          console.error('获取消息列表失败:', res.message);
        }
      }).catch(err => {
        this.loading = false;
        console.error('调用接口失败:', err);
      });
    },
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      // 如果日期格式为 "2020-09-03 12:00:00"，只取日期部分
      return dateStr.split(' ')[0];
    },
    // 返回按钮点击事件
    onClickLeft() {
      this.$router.back();
    },
    // 消息点击事件
    onMessageClick(item) {
      console.log('点击消息:', item);
      // 跳转到消息详情页面
      this.$router.push({
        name: 'messageDetail',
        params: {
          notificationId: item.notificationId
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/page/srm/imManage/SrmIMManage.vue